module.exports = __webpack_public_path__ + "static/media/ImgNovedades220915_1.c889d670.jpg";